import React from 'react'
import { Typography } from '@mui/material';

type TProps = {
    title: string | React.ReactNode,
    fontColor: string | undefined
}

const TitleWithBack:React.FC<TProps> = ({ fontColor, title }) => {
  return (
    <Typography variant="h5" align="center" color={fontColor} marginBottom="20px">{title}</Typography>
  )
}

export default TitleWithBack